import { usePageContext } from '@/common/context/pageContext';

export const useDetailLogger = () => {
    const { logger } = usePageContext();

    const logItemDesc = () => {
        logger.sendShow({
            action: 'PRODUCT_DESCRIPTION',
        });
    };

    const logShowSameItems = () => {
        logger.sendShow({
            action: 'SAME_ITEM_RECOMMEND_FLOOR',
        });
    };

    const logClickSameItem = (params: {
        item_id: string | number;
        media_source: string | number;
        tag_code?: string;
        index?: number;
        llsid?: string | number;
        exp_tag?: string | number;
        media_id?: string | number;
        button_type?: 1 | 2; //1 : 立即购买; 2 : 跳转商详
    }) => {
        logger.sendClick({
            action: 'SAME_ITEM_RECOMMEND_PRODUCT',
            params,
        });
    };

    const logShowSameItem = (params: {
        item_id: string | number;
        media_source: string | number;
        tag_code?: string;
        index?: number;
        llsid?: string | number;
        exp_tag?: string | number;
        media_id?: string | number;
    }) => {
        logger.sendShow({
            action: 'SAME_ITEM_RECOMMEND_PRODUCT',
            params,
        });
    };

    const logShowAddress = (source: string) => {
        logger.sendShow({
            action: 'ADDRESS',
            params: {
                source,
            },
        });
    };

    // 是否授权定位 1-同意授权，0-未授权
    const logIfGpsPermission = (state: 0 | 1) => {
        logger.sendShow({
            action: 'IS_EMPOWER_POSITION',
            params: {
                state,
            },
        });
    };

    const logShowBigSalesBanner = (params: { item_id: string | number; type: string }) => {
        logger.sendShow({
            action: 'CUMMERBUND_BENEFIT',
            params,
        });
    };

    const logClickBigSalesBanner = (params: { item_id: string | number; type: string }) => {
        logger.sendClick({
            action: 'CUMMERBUND_BENEFIT',
            params,
        });
    };

    const logClickRankBanner = () => {
        logger.sendClick({
            action: 'RANK_LIST_FLOOR',
        });
    };

    const logShowRankBanner = () => {
        logger.sendShow({
            action: 'RANK_LIST_FLOOR',
        });
    };

    const logClickRankBtn = () => {
        logger.sendClick({
            action: 'RANK_BUTTON',
        });
    };

    const logShowRankProduction = ({ item_id, media_source, index }) => {
        logger.sendShow({
            action: 'RANK_PRODUCT_CARD',
            params: {
                item_id,
                media_source,
                index,
            },
        });
    };

    const logClickRankProduction = ({ item_id, media_source, index }) => {
        logger.sendClick({
            action: 'RANK_PRODUCT_CARD',
            params: { item_id, media_source, index },
        });
    };

    const logShowRankImage = () => {
        logger.sendShow({
            action: 'MAIN_GRAPH_RANK',
        });
    };

    return {
        logClickRankBtn,
        logShowRankImage,
        logShowRankProduction,
        logClickRankProduction,
        logItemDesc,
        logShowSameItems,
        logClickSameItem,
        logShowSameItem,
        logShowAddress,
        logIfGpsPermission,
        logShowBigSalesBanner,
        logClickBigSalesBanner,
        logClickRankBanner,
        logShowRankBanner,
    };
};
